const t=t=>t<=50?"right":"left";export{t as getTooltipPlacement};
//# sourceMappingURL=CMSImageMapPreview.helpers.js.map
